import { Table } from '@tanstack/react-table'
import { useMemo } from 'react'

export function useFrozenColumns<TData>(
  table: Table<TData>,
  freezePane: number | undefined,
  computedColWidths: Record<string, number>
) {
  const leafColumns = table.getAllLeafColumns()
  
  const frozenColOffsetsById = useMemo(() => {
    if (!freezePane) return {}
    const offsets: Record<string, number> = {}
    let acc = 0
    for (let i = 0; i < leafColumns.length && i < freezePane; i++) {
      const col = leafColumns[i]
      offsets[col.id] = acc
      acc += col.columnDef.size ?? computedColWidths[col.id] ?? 0
    }
    return offsets
  }, [freezePane, leafColumns, computedColWidths])

  return { leafColumns, frozenColOffsetsById }
}

